import React, { useRef, useState } from 'react';
import { isAxiosError } from 'axios';
import { FormComponent, UiComponent } from 'components';
import { AdminsQuery } from 'queries';
import useModal from 'hooks/useModal';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import RoleSelect from '../RoleSelect';
import PasswordResult from '../PasswordResult';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// 어드민 등록 — 비밀번호는 서버가 생성해 한 번만 돌려준다
function AdminForm() {
  const { handleClose, handleAlert, handleModal } = useModal();
  const { mutateAsync: create, isPending } = AdminsQuery.useCreate();
  const usernameRef = useRef<HTMLInputElement>(null);
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);

  const [roleId, setRoleId] = useState('');

  const handleSubmit = async () => {
    const username = usernameRef.current?.value.trim() ?? '';
    const name = nameRef.current?.value.trim() ?? '';
    const email = emailRef.current?.value.trim() ?? '';

    if (!username || !name || !email) {
      handleAlert('아이디, 이름, 이메일을 입력해주세요');
      return;
    }
    if (!EMAIL_PATTERN.test(email)) {
      handleAlert('이메일 형식을 확인해주세요');
      return;
    }
    if (!roleId) {
      handleAlert('할당할 권한을 선택해주세요');
      return;
    }

    try {
      const { data } = await create({
        username,
        name,
        email,
        roleIds: [Number(roleId)],
      });
      handleClose();
      handleModal(
        '계정 생성 완료',
        <PasswordResult result={data} message="계정이 생성되었습니다." />,
        <></>,
      );
    } catch (error) {
      const status = isAxiosError(error) ? error.response?.status : undefined;
      const message = isAxiosError<{ message?: unknown }>(error)
        ? error.response?.data?.message
        : undefined;
      toast.error(
        status === 409 && typeof message === 'string'
          ? message
          : DEFAULT_ERROR_MESSAGE,
      );
    }
  };

  return (
    <div
      css={{
        width: '400px',
        '> p': { margin: '16px 0 8px', fontWeight: '600' },
      }}
    >
      <p>아이디</p>
      <FormComponent.Input
        ref={usernameRef}
        placeholder="로그인 아이디"
        maxLength={50}
        css={{ width: '100%' }}
      />
      <p>이름</p>
      <FormComponent.Input
        ref={nameRef}
        placeholder="담당자 이름"
        maxLength={50}
        css={{ width: '100%' }}
      />
      <p>이메일</p>
      <FormComponent.Input
        ref={emailRef}
        type="email"
        placeholder="example@yvis.org"
        maxLength={100}
        css={{ width: '100%' }}
      />
      <p>할당 권한</p>
      <RoleSelect roleId={roleId} onChange={setRoleId} />
      <p css={{ fontSize: 13, color: '#888', fontWeight: 400 }}>
        초기 비밀번호는 등록 후 한 번만 표시됩니다.
      </p>
      <div css={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <UiComponent.Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isPending}
        >
          등록하기
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default AdminForm;
